// extracted by mini-css-extract-plugin
export default {"areaReport":"AreaReport_areaReport__sIfPr","controlPanel":"AreaReport_controlPanel__5HC5R","scrollable":"AreaReport_scrollable__AI0+a"};